import React from "react";
import { darkTheme } from "@yleisradio/yds-core";
import { Replay } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import {
  CenterFloatingButton,
  CenterFloatingWrapper
} from "../PlayButton/CenterFloatingButton";

const ReplayButtonStyled = styled(CenterFloatingButton)<{ label: string }>`
  height: ${({ isMobile }) => (isMobile ? "58px" : "")};
  position: relative;
  width: ${({ isMobile }) => (isMobile ? "58px" : "")};
  z-index: 9;

  &:after {
    content: "${({ label }) => label}";
    color: ${darkTheme.TEXT_DEFAULT};
    font:
      700 18px "Yle Next",
      "Open Sans",
      sans-serif;
    line-height: 21px;
    letter-spacing: 0;
    margin-top: 10px;
    position: absolute;
    text-align: left;
    text-transform: none;
    top: 100%;
    white-space: nowrap;
  }
`;

export const ReplayButton = () => {
  const { useStoreState } = usePlayerStore();
  const device = useStoreState.device();
  const player = useStoreState.player();

  const { language } = useEmbedParametersContext();

  const label = i18n("toista_uudelleen", { language });

  return (
    <CenterFloatingWrapper onClick={() => player.play()}>
      <ReplayButtonStyled
        aria-label={label}
        isMobile={device.isMobile}
        label={label}>
        <Replay
          width={device.isMobile ? 28 : 42}
          height={device.isMobile ? 28 : 42}
        />
      </ReplayButtonStyled>
    </CenterFloatingWrapper>
  );
};
